<template>
  <v-container fluid class="pa-2">
    <v-row>
      <v-col v-if="impersonationAlert">
        <v-alert
          type="warning"
          v-model="impersonationAlert"
          class="my-0 banner-close-icon"
          closable
          density="compact"
          variant="outlined"
        >
          You're currently impersonating: {{ impersonatedAgent }}
        </v-alert>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <overview v-if="isBrokerAdmin || impersonating" />

        <lender-overview v-if="isLoanOfficer || impersonatingLender" />

        <!-- TODO: Remove this option and change to redirect -->
        <!-- <console-brokerages v-if="isAdmin && !impersonating" class="testing" />-->
      </v-col>
    </v-row>

    <impersonation-dialog
      :dialog.sync="impersonationDialog"
      :dialogType="impersonateDialogType"
      :brokerageName.sync="impersonatedAgent"
      @cancel="impersonateCancel"
      @disable="disableImpersonation"
    />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import Overview from "@/components/console/dashboard/Overview.vue";
// import ConsoleBrokerages from "@/components/console/brokerages/BrokeragesList.vue";
import ImpersonationDialog from "@/components/console/dialog/ImpersonationDialog.vue";
import LenderOverview from "@/components/console/lender-dashboard/LenderOverview";

export default {
  name: "dashboard",
  props: {},
  components: {
    LenderOverview,
    Overview,
    // ConsoleBrokerages,
    ImpersonationDialog,
  },
  data() {
    return {
      impersonationAlert: false,
      impersonationDialog: false,
      impersonateDialogType: "disableImpersonate",
    };
  },
  methods: {
    impersonateCancel() {
      this.impersonationAlert = true;
      this.impersonationDialog = false;
    },
    disableImpersonation() {
      let route = "/console";
      if (this.impBrokerage) {
        route = "/console/brokerages";
      } else if (this.impLoanOffice) {
        route = "/console/lenders";
      }

      this.$store.dispatch("auth/clearImpersonate").then(() => {
        this.impersonationDialog = false;
        this.$router.push(route);
      });
    },
  },
  computed: {
    ...mapGetters("user", ["me", "isAdmin", "isLoanOfficer", "isBrokerAdmin"]),
    ...mapGetters("auth", [
      "creds",
      "impBrokerage",
      "impLoanOffice",
      "impUser",
    ]),
    impersonating() {
      return this.impBrokerage !== null;
    },
    impersonatingLender() {
      return this.impLoanOffice !== null;
    },
    impersonatedAgent() {
      if (this.impBrokerage?.name) {
        return this.impBrokerage.name;
      } else if (this.impLoanOffice?.name) {
        return this.impLoanOffice.name;
      }

      return "";
    },
    // impersonationAlert() {
    //   return this.impBrokerage !== null || this.impLoanOffice !== null;
    // },
  },
  watch: {
    impBrokerage() {
      this.impersonationAlert =
        this.impBrokerage !== null || this.impLoanOffice !== null;
      // if (this.impBrokerage !== null || this.impLoanOffice !== null) {
      //   this.impersonationAlert = true;
      // }
    },
    impersonationAlert(n) {
      if (n === false) {
        this.impersonationDialog = true;
      }
    },
  },
  mounted() {
    if (this.isAdmin && !this.impersonating && !this.impersonatingLender) {
      this.$router.push("/console/brokerages");
    }

    this.impersonationAlert =
      this.impBrokerage !== null || this.impLoanOffice !== null;
  },
  created: function () {},
};
</script>

<!-- styling for the component -->
<style scoped>
.banner-close-icon :deep(.v-btn .v-icon) {
  font-size: 20px !important;
}
.v-alert :deep(.v-icon) {
  font-size: 22px !important;
  margin-top: 6px;
}
</style>
